'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderEntity = exports.renderArray = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Entity = require('./Entity');

var _Entity2 = _interopRequireDefault(_Entity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderArray(item) {
  if (item && item.constructor === Array) {
    if (item.length > 0) {
      return item.join(', ').toString();
    }
  } else if (item) {
    return item;
  } else {
    return null;
  }
}

function renderEntity(entityData) {
  return _react2.default.createElement(_Entity2.default, {
    identifiers: entityData.identifiers,
    code: entityData.code,
    addresses: entityData.addresses,
    phones: entityData.phones,
    person: entityData.person,
    title: entityData.title,
    organization: entityData.organization
  });
}

exports.renderArray = renderArray;
exports.renderEntity = renderEntity;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/customSections/customSectionSharedFunctions.js
// module id = 139
// module chunks = 0